import {
  Body2,
  Card,
  Checkbox,
  Display1,
  Display2,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '@sainsburys-tech/fable'
import { SparkFilled, Tick } from '@sainsburys-tech/icons'
import React from 'react'

import { IPicklistItem } from '../../types/IPicklistItem'

interface IGOLPlannerGroupTable {
  plannerGroupName: string
  pickList: IPicklistItem[]
  handleSkuCheckChange: (pickListItem: IPicklistItem) => void
}

const GOLPlannerGroupTable = ({
  plannerGroupName,
  pickList,
  handleSkuCheckChange,
}: IGOLPlannerGroupTable) => {
  const renderSkuCheckbox = (pickListItem: IPicklistItem) => (
    <div>
      <Checkbox
        isStandalone
        label={pickListItem.sainId}
        id={pickListItem.sainId}
        name={pickListItem.sainId}
        isChecked={pickListItem.completed}
        onChange={() => handleSkuCheckChange(pickListItem)}
        testid='gol-checkbox'
      />
    </div>
  )

  const allCompleted = (items: IPicklistItem[]): boolean =>
    items.every((item) => item.completed)

  return (
    <div>
      <Display2 style={{ paddingBottom: '16px', paddingTop: '20px' }}>
        {plannerGroupName}
        {allCompleted(pickList) && (
          <span className='c-gol-planner-group-complete'>{<Tick />}</span>
        )}
      </Display2>

      <Card orientation='vertical' data-testid='gol-planner-group-card'>
        <Table testid='gol-table' className='c-gol-table'>
          <TableHeader>
            <TableRow>
              <TableCell className='c-gol-col-check'>
                <Display1>Packed</Display1>
              </TableCell>
              <TableCell className='c-gol-col-qty'>
                <Display1>Qty</Display1>
              </TableCell>
              <TableCell>
                <Display1>Product</Display1>
              </TableCell>
              <TableCell className='c-gol-col-skuId'>
                <Display1>SKU Code</Display1>
              </TableCell>
              <TableCell className='c-gol-col-sainId'>
                <Display1>PLU Code</Display1>
              </TableCell>
            </TableRow>
          </TableHeader>

          <TableBody>
            {pickList.map((item: IPicklistItem) => (
              <TableRow>
                <TableCell>{renderSkuCheckbox(item)}</TableCell>
                <TableCell>
                  <Body2>{item.quantity}</Body2>
                </TableCell>
                <TableCell>
                  <Body2>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <span>{item.skuName}</span>
                      {item.isCredibleProduct && (
                        <SparkFilled className='c-star__icon' />
                      )}
                    </span>
                  </Body2>
                </TableCell>
                <TableCell>
                  <Body2>{item.skuId}</Body2>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  )
}

export default GOLPlannerGroupTable
